// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '../../router'
import VueResource from 'vue-resource'
import store from '../../vuex/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '../../global/proto'
import globalData from '../../global/data'

import filter from '../../utils/filter'
import notice from '../../utils/notice'
import common from '../../utils/common'
import http from '../../utils/http'


Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueResource)

Vue.use(globalData)

Vue.use(filter)
Vue.use(notice)
Vue.use(common)
Vue.use(http)

Vue.http.interceptors.push(function (request, next) {
  let loginUser = this.$getCookie('METER_LOGIN_USER')
  console.log(loginUser)
  if(loginUser){
    // request.headers.set('accessToken', loginUser.accessUserId || null)
    // request.headers.set('accessUserId', loginUser.id || null)
  }
  next(function (response) {
    return response
  });

})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,router,
  components: {App},
  template: '<App/>',
  data(){
    return{

    }
  },
  beforeMount(){
    // this.getTaskMap()
  },
  methods:{
    // getTaskMap(){
    //   this.$http$({method:'get',url:'/smartMeterServer/MonitorDataTab/setting'},(data) => {
    //     let map = {}
    //     for (var i in data) {
    //       map[data[i].dataitem] = data[i].proname
    //     }
    //     map.czDate = '抄收日期'
    //     map.MeterNo = '表号'
    //     map.ConNo = '中继器号'
    //     map.MonitorType = '监控类型'
    //     this.$store.commit('setTasKeyMa',map)
    //   })
    // }
  },
  watch:{
    '$route'(to,from){
      let path = to.path
      this.$store.commit('setCurrentPath',path)
    }
  }
})



// WEBPACK FOOTER //
// ./src/entrance/index/main.js